module.exports = __webpack_public_path__ + "img/de.c474b726.png";